import { useImageCardForm } from "@/components/shared/forms/image-card-form";
import type { CommonColor } from "@stackje/common/config";

export function AddImageCard(
  defaultType: "image1" | "image2" | "image3" | "image4" | "image5",
  defaultColors: CommonColor
) {
  const { formContent, previewContent, toggleType, shuffleColors, handleSubmit } =
    useImageCardForm({
      initialData: {
        title: "",
        description: "",
        images: [],
        type: defaultType,
        colors: defaultColors,
      },
      mode: "add",
    });

  return {
    formContent,
    previewContent,
    toggleType,
    shuffleColors,
    handleSubmit,
  };
}